var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"v-toast-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
      'v-toast-wrap' ].concat( _vm.classNames,
      [_vm.platformTheme],
      [{
        'reg-success': _vm.isRegSuccess
      }]
    ),style:({
      top: _vm.top ? (_vm.top + "px") : null
    })},[(_vm.dangerouslyUseHTMLString)?_c('span',{staticClass:"v-toast",domProps:{"innerHTML":_vm._s(_vm.message)}}):_c('span',{staticClass:"v-toast",class:[
        _vm.type,
        {
          'reg-success': _vm.isRegSuccess
        }
      ]},[(_vm.isRegSuccess)?_c('img',{staticClass:"icon-success",attrs:{"src":require("./images/reg-success@2x.png")}}):(_vm.type === 'info')?_c('img',{staticClass:"icon",attrs:{"src":require("./images/info.png")}}):(_vm.type === 'error')?_c('img',{staticClass:"icon",attrs:{"src":require("./images/error.png")}}):(_vm.type === 'success')?_c('img',{staticClass:"icon",attrs:{"src":require("./images/success.png")}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.message)+"\n      "),(_vm.closeable)?_c('img',{staticClass:"icon-close",attrs:{"src":require("./images/close@2x.png"),"alt":"close"},on:{"click":_vm.close}}):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }